import React from 'react';

import { WarmChatContextBannerLink } from '@atlassian/conversation-assistant-chat-prompt-input/controllers/warm-chat-context-banner-link';
import { useUIStore } from '@atlassian/conversation-assistant-store/controllers/ui-store';

import { useConversation } from '../conversation/useConversation';

type WarmChatContextBannerLinkControllerProps = {
	enableBrowserContextBanner?: boolean;
	shouldShowContextBanner?: boolean;
	stagingAreaEnabled?: boolean;
};

/**
 * Keeps the early Smart Link warmer mounted near chat-open startup while deriving
 * the same high-level context-banner render guards as the actual ChatInput path.
 */
export const WarmChatContextBannerLinkController = ({
	enableBrowserContextBanner,
	shouldShowContextBanner,
	stagingAreaEnabled,
}: WarmChatContextBannerLinkControllerProps): JSX.Element => {
	const { conversation } = useConversation();
	const { isChatOnboardingMiniModalOpen, selectedSpace } = useUIStore();
	const useCurrentPageContext =
		shouldShowContextBanner !== false && !stagingAreaEnabled && !isChatOnboardingMiniModalOpen;
	const isSpaceScopedConversation = Boolean(conversation?.rovoSpaceId || selectedSpace);

	return (
		<WarmChatContextBannerLink
			enableBrowserContextBanner={enableBrowserContextBanner}
			useCurrentPageContext={useCurrentPageContext}
			isSpaceScopedConversation={isSpaceScopedConversation}
		/>
	);
};
